export default __webpack_public_path__ + "static/media/image18.b5009d0e.jpg";